import { createReducer, createActions } from "reduxsauce";

/**
 * ------------- Types and Action Creators -------------
 * The keys of the object will become keys of the Creators.
 * They will also become the keys of the Types after being
 * converted to SCREAMING_SNAKE_CASE.
 */
const { Types, Creators } = createActions({
  fetchBidDetails: ["id"],
  fetchBidDetailsFailure: null,
  fetchBidDetailsSuccess: ["data"],
  setPaymentMethod: ["paymentMethod"],
  clearBiddingData: null,
});

export const BidDetailsTypes = Types;
export default Creators;

/* ------------- Initial State ------------- */

export const INITIAL_STATE = {
  bid: {
    id: null,
    message: null,
    isAccepted: false,
    isCanceled: false,
    isAwarded: false,
    isSubmitted: false,
    isDeclined: false,
    isWithdrawn: false,
    isExpired: false,
    payByCheck: false,
    timeZone: "America/Chicago",
    createdAt: new Date(),
    amount: 0,
    user: {},
    listing: {
      farm: {
        city: {
          state: {},
        },
      },
    },
    estimateRequest: {},
    signers: [],
  },
  selectedPaymentMethod: null,
  isFetching: false,
  isInvitingSigners: false,
  isRemovingSigner: {},
};

/* ------------- Reducers ------------- */

export const fetchBidDetails = (state = INITIAL_STATE) => ({
  ...state,
  isFetching: true,
});

export const fetchBidDetailsFailure = (state = INITIAL_STATE) => ({
    ...state,
    isFetching: false,
  });

export const fetchBidDetailsSuccess = (state = INITIAL_STATE, action) => {
  const { data } = action;
  // TODO: clean up state data
  return {
    ...state,
    bid: data,
    isFetching: false,
  };
};

export const setPaymentMethod = (state = INITIAL_STATE, action) => {
  const { paymentMethod } = action;

  return {
    ...state,
    selectedPaymentMethod: paymentMethod,
  };
};

export const clearBiddingData = () => INITIAL_STATE;

/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.FETCH_BID_DETAILS]: fetchBidDetails,
  [Types.FETCH_BID_DETAILS_FAILURE]: fetchBidDetailsFailure,
  [Types.FETCH_BID_DETAILS_SUCCESS]: fetchBidDetailsSuccess,
  [Types.SET_PAYMENT_METHOD]: setPaymentMethod,
  [Types.CLEAR_BIDDING_DATA]: clearBiddingData,
});
